import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { FaHome } from 'react-icons/fa';
// استيراد ملف الأنيميشن المحلي
import animationPath from '../assets/animations/lottie/404animation.lottie';

const NotFound = () => {
  const containerRef = useRef(null);
  
  useEffect(() => {
    // تحميل سكريبت dotlottie-player من الإنترنت
    const script = document.createElement('script');
    script.src = 'https://unpkg.com/@dotlottie/player-component@2.7.12/dist/dotlottie-player.mjs';
    script.type = 'module';
    script.async = true;
    
    script.onload = () => {
      if (containerRef.current) {
        const player = document.createElement('dotlottie-player');
        // استخدام ملف الأنيميشن المحلي
        player.setAttribute('src', animationPath);
        player.setAttribute('background', 'transparent');
        player.setAttribute('speed', '1');
        player.setAttribute('loop', '');
        player.setAttribute('autoplay', '');
        player.style.width = '100%';
        player.style.height = '100%';
        
        containerRef.current.innerHTML = '';
        containerRef.current.appendChild(player);
      }
    };
    
    document.head.appendChild(script);
    
    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);
  
  return (
    <div className="min-h-screen bg-gray-100 dark:bg-gray-900 flex flex-col justify-center items-center p-4">
      <div className="text-center w-full max-w-md md:max-w-xl">
        <div 
          ref={containerRef}
          className="w-full h-[250px] sm:h-[300px] md:h-[400px] mx-auto mb-2 overflow-hidden"
        >
          {/* الأنيميشن هتظهر هنا */}
        </div>
        <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 dark:text-gray-200 mt-2 mb-3">
          الصفحة غير موجودة
        </h2>
        <p className="text-base sm:text-lg text-gray-600 dark:text-gray-400 mb-5 px-2">
          عذراً، الصفحة التي تبحث عنها غير موجودة أو تم نقلها.
        </p>
        <Link
          to="/"
          className="flex items-center justify-center gap-2 px-5 py-2.5 bg-primary-600 hover:bg-primary-700 text-white rounded-lg text-base sm:text-lg font-medium transition-colors duration-300 w-fit mx-auto"
        >
          <FaHome className="text-lg" />
          العودة للرئيسية
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
